<template>
    <div class="ds-urv-key-screen">
        <btn class="ds-urv-return ds-urv-return-absolute" @click="emit('close')">
            Вернуться к расписанию
        </btn>
        <div class="ds-urv-key-card">
            <h1 class="ds-urv-title">Введите ключ</h1>
            <form class="ds-urv-key-form" @submit.prevent="emit('submit', key)">
                <label class="ds-urv-key-label" for="urv-access-key">Ключ доступа</label>
                <input id="urv-access-key" v-model="key" class="ds-urv-key-input" type="text" required autofocus :disabled="isSubmitting">
                <b-button class="ds-urv-key-submit" type="submit" :disabled="isSubmitting">
                    {{ isSubmitting ? 'Подключение…' : 'Подключиться' }}
                </b-button>
                <p v-if="errorMessage" class="ds-urv-form-error" role="alert">{{ errorMessage }}</p>
            </form>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const key = ref('')

defineProps<{
    isSubmitting: boolean
    errorMessage: string
}>()

const emit = defineEmits<{
    (event: 'submit', key: string): void
    (event: 'close'): void
}>()
</script>
